import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';

const Filter = ({ search, setSearch, filtered }) => {
  const { t } = useTranslation();
  const countLabel = filtered.length === 1
    ? t('screens.riskCarriers.countOne',  { count: filtered.length, defaultValue: '{{count}} carrier' })
    : t('screens.riskCarriers.countMany', { count: filtered.length, defaultValue: '{{count}} carriers' });
  return (
    <div
      style={{
        padding: '12px 32px',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.5)',
        flexShrink: 0,
      }}
    >
      <div style={{ position: 'relative', flex: 1, minWidth: 240, maxWidth: 380 }}>
        <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <Icon name='search' color='#94a3b8' size={15} />
        </div>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={t('screens.riskCarriers.searchPlaceholder', { defaultValue: 'Search by name, code, or location…' })}
          style={{
            width: '100%',
            padding: '9px 12px 9px 36px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            color: S.textPrimary,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <span style={{ marginLeft: 'auto', fontSize: 12, color: S.textMuted }}>
        {countLabel}
      </span>
    </div>
  );
};

export default Filter;
